import React from "react";
import PropTypes from "prop-types";
import {
    Input,
    Select,
    DatePicker,
    Button
    // AutoComplete
} from "antd";
import { Map } from "immutable";
import { REPORTS_FILTER_TYPES, REPORTS_OPTIONS_TYPES } from "constants/enums";
import { ReportsService } from "services";

const FILTER_TYPES_KEYS = REPORTS_FILTER_TYPES.map((v, k) => k).toJS();
// const FILTER_OPTION_KEYS = REPORTS_OPTIONS_TYPES.map((v, k) => k).toJS();

function getBaseComponent(type) {
    switch (type) {
    case FILTER_TYPES_KEYS.DATE:
    case FILTER_TYPES_KEYS.DATETIME:
        return DatePicker;
    case FILTER_TYPES_KEYS.INPUT:
        return Input;
    case FILTER_TYPES_KEYS.SINGLE_SELECT:
    case FILTER_TYPES_KEYS.MULTI_SELECT: {
        // if (optionsType === FILTER_OPTION_KEYS.SEARCH) {
        //     return AutoComplete;
        // }
        return Select;
    }
    default:
        return <div />;
    }
}

const getComp = config => {
    const typeLabel = REPORTS_FILTER_TYPES.findKey(_ => _ === config.type);
    const optionsLabel = REPORTS_OPTIONS_TYPES.findKey(
        _ => _ === config.selectType
    );
    const isDropdown = [
        FILTER_TYPES_KEYS.SINGLE_SELECT,
        FILTER_TYPES_KEYS.MULTI_SELECT
    ].includes(typeLabel);
    // const isAutoComplete = optionsLabel === FILTER_OPTION_KEYS.SEARCH;
    const isDateFilter = [
        FILTER_TYPES_KEYS.DATE,
        FILTER_TYPES_KEYS.DATETTIME
    ].includes(typeLabel);
    const BaseComp = getBaseComponent(typeLabel, optionsLabel);
    return class extends React.Component {
        state = {
            loading: false,
            options: [],
            searchKeyword: ""
        };
        componentDidMount() {
            if (isDropdown) {
                this.getOptions("");
            }
        }

        onChange = (value, auto = false) => {
            if (isDropdown) {
                // const valueProp = this.state.options.find(
                //     _ => _[config.selectLabelProp] === value
                // )[config.selectValueProp];
                return this.props.onChange(config.key, value, auto);
            }
            if (isDateFilter) {
                return this.props.onChange(config.key, value, auto);
            }
            this.props.onChange(config.key, value.target.value, auto);
        };
        onSearch = searchKeyword => {
            this.getOptions(searchKeyword);
        };
        getOptions(searchKeyword) {
            if (config.defaultList) {
                this.setState(
                    {
                        loading: false,
                        options: config.defaultList.map((_, index) => ({
                            key: index,
                            ..._
                        }))
                    },
                    () =>
                        !this.props.value && this.state.options.length === 1
                            ? this.onChange(
                                String(
                                    this.state.options[0][
                                        config.selectValueProp
                                    ]
                                ),
                                true
                            )
                            : null
                );
            }

            this.setState({
                loading: true
            });
            ReportsService.getReportOptions(
                config.selectOptionUrl + searchKeyword
            ).then(_ => {
                this.setState(
                    {
                        loading: false,
                        options: _.data.map((_, index) => ({
                            key: index,
                            ..._
                        }))
                    },
                    () =>
                        !this.props.value && this.state.options.length === 1
                            ? this.onChange(
                                String(
                                    this.state.options[0][
                                        config.selectValueProp
                                    ]
                                ),
                                true
                            )
                            : null
                );
            });
        }
        getChildren() {
            if (isDropdown) {
                return this.state.options.map(_ => (
                    <BaseComp.Option
                        key={_.key}
                        label={_[config.selectLabelProp]}
                        value={String(_[config.selectValueProp])}
                    >
                        {_[config.selectLabelProp]}
                    </BaseComp.Option>
                ));
            }
            return null;
        }

        getProps() {
            switch (typeLabel) {
            case FILTER_TYPES_KEYS.SINGLE_SELECT:
                return {
                    showSearch: true,
                    onSearch: this.onSearch,
                    mode: "default",
                    placeholder: config.placeholder,
                    loading: this.state.loading,
                    optionFilterProp: "label",
                    style: {
                        minWidth: "200px"
                    }
                };
            case FILTER_TYPES_KEYS.MULTI_SELECT:
                return {
                    showSearch: true,
                    onSearch: this.onSearch,
                    mode: "tags",
                    placeholder: config.placeholder,
                    loading: this.state.loading,
                    optionFilterProp: "label",
                    style: {
                        minWidth: "200px"
                    }
                };

            default:
                return {
                    placeholder: config.placeholder,
                    style: {
                        minWidth: "200px"
                    }
                };
            }
        }
        render() {
            return (
                <BaseComp
                    value={this.props.value}
                    onChange={this.onChange}
                    className={"p-5"}
                    {...this.getProps()}
                >
                    {this.getChildren()}
                </BaseComp>
            );
        }
        static displayName = "FilterType" + BaseComp.displayName;
        static propTypes = {
            key: PropTypes.string,
            value: PropTypes.any,
            onChange: PropTypes.func
        };
    };
};

class ReportsFilter extends React.Component {
    buildComponent() {
        if (this.props.filters.size && !this.components) {
            this.components = this.props.filters.map(_ => getComp(_));
        }
    }
    onChange = (key, value, auto = false) => {
        this.props.onApply(
            {
                ...this.props.values,
                [key]: value
            },
            this.props.filters.size === 1 ? auto : false
        );
    };
    onSubmit = () => this.props.onFetch();

    getURL() {
        const { reportId } = this.props;

        return (
            `${process.env.BASE_URL}/report/${reportId}/download/?` +
            new Map(this.props.values)
                .map(
                    (v, k) =>
                        `${k}=${
                            v.length && typeof v === "object"
                                ? JSON.stringify(v)
                                : v
                        }`
                )
                .reduce(
                    (agg, cur) => (agg.length > 0 ? agg + "&&" + cur : cur),
                    ""
                )
        );
    }
    render() {
        this.buildComponent();
        return (
            <div className={"d-flex align-items-center mb-5"}>
                {this.props.filters
                    .map(_ => {
                        const FilterComp = this.components.get(_.key);
                        return (
                            <FilterComp
                                key={_.key}
                                value={this.props.values[_.key]}
                                onChange={this.onChange}
                            />
                        );
                    })
                    .toList()}
                {this.props.filters.size ? (
                    <React.Fragment>
                        <Button
                            type={"primary"}
                            onClick={this.onSubmit}
                            className={"px-5"}
                        >
                            {" "}
                            Fetch{" "}
                        </Button>
                    </React.Fragment>
                ) : null}
            </div>
        );
    }
}

ReportsFilter.propTypes = {
    reportId: PropTypes.number,
    filters: PropTypes.object,
    values: PropTypes.object,
    onApply: PropTypes.func,
    onFetch: PropTypes.func
};

export default ReportsFilter;
